import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthLoginGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(): Observable<boolean> {
    return new Observable<boolean>((subscriber) => {
      this.authService.currentUser.subscribe((user) => {
        if (user) {
          this.router.navigate(['/despacho']);
          subscriber.next(false);
        } else {
          subscriber.next(true);
        }
      });
    });
  }
}
